export default __webpack_public_path__ + "static/media/raki_detail14.99823c1f.jpg";